import React from "react";
import {useTranslation} from "react-i18next";
import {NumberInput} from "../../orderReportPage.styles";
import {PieReportWidget} from "../PieReportWidget/PieReportWidget";

export const DurationStatsWidget = ({data, loading, duration, onChangeDuration}) => {
    const {t} = useTranslation(["durationStatsWidget"]);
    const durationData = [
        {
            name: t("durationData.onTime", {ns: "durationStatsWidget"}),
            value: data?.percentage,
            color: "#72ECA5"
        },
        {
            name: t("durationData.delayed", {ns: "durationStatsWidget"}),
            value: 100 - data?.percentage,
            color: "#FA7880"
        }
    ];
    return (
        <PieReportWidget
            data={durationData}
            loading={loading}
            title={
                <h3 style={{display: "flex"}}>
                    <NumberInput
                        data-testid="minuteInput"
                        onBlur={e => {
                            if (!Number(e.target.value) || e.target.value.length === 0) {
                                return;
                            }

                            onChangeDuration(Math.max(0, Math.min(e.target.value, 99)));
                        }}
                        type="number"
                        inputMode="numeric"
                        min={0}
                        max={99}
                        defaultValue={duration}
                    />{" "}
                    <span style={{marginLeft: "5px"}}>
                        {t("minutesInDelivered", {ns: "durationStatsWidget"})}
                    </span>
                </h3>
            }
            unitLabel="%"
        />
    );
};
